// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Onboarding resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class OnboardingClient {
  constructor(private readonly http: HttpClient) {}

  /** Get Onboarding via the Inferrex API. */
  async getOnboarding(): Promise<{ active: boolean; id: string | null; customerId: string; step: string | null; phase1ConnectionId: string | null; phase2ConnectionId: string | null; archivalEnabled: boolean | null; syncTierConfig: Record<string, unknown> | null; pipelineId: string | null; createdAt: string | null; completedAt: string | null }> {
    return this.http.get<{ active: boolean; id: string | null; customerId: string; step: string | null; phase1ConnectionId: string | null; phase2ConnectionId: string | null; archivalEnabled: boolean | null; syncTierConfig: Record<string, unknown> | null; pipelineId: string | null; createdAt: string | null; completedAt: string | null }>('/v1/onboarding');
  }

  /** Get Onboarding Entity Sync Tiers via the Inferrex API. */
  async getOnboardingEntitySyncTiers(options?: { connectionId?: string | undefined }): Promise<{ connectionId: string; suggestions: { entityId: string; displayName: string; suggestedTier: string; rationale: string; confidence: number | null }[] }> {
    return this.http.get<{ connectionId: string; suggestions: { entityId: string; displayName: string; suggestedTier: string; rationale: string; confidence: number | null }[] }>('/v1/onboarding/entity-sync-tiers', options);
  }

  /** Get Onboarding Archival Analysis via the Inferrex API. */
  async getOnboardingArchivalAnalysis(options?: { connectionId?: string | undefined }): Promise<{ connectionId: string; eligibleEntities: number; estimatedRecords: number | null; estimatedMonthlySaving: number | null; isEstimate: boolean }> {
    return this.http.get<{ connectionId: string; eligibleEntities: number; estimatedRecords: number | null; estimatedMonthlySaving: number | null; isEstimate: boolean }>('/v1/onboarding/archival-analysis', options);
  }

  /** Start Onboarding via the Inferrex API. */
  async startOnboarding(requestOptions?: RequestOptions): Promise<{ id: string; customerId: string; step: string }> {
    return this.http.post<{ id: string; customerId: string; step: string }>('/v1/onboarding/start', undefined, requestOptions);
  }

  /** Advance Onboarding via the Inferrex API. */
  async advanceOnboarding(request: { phase1ConnectionId?: string; phase2ConnectionId?: string; archivalEnabled?: boolean; syncTierConfig?: Record<string, unknown>; pipelineId?: string; mappingApproved?: boolean; mappingId?: string; activate?: boolean }, requestOptions?: RequestOptions): Promise<{ id: string; step: string }> {
    return this.http.post<{ id: string; step: string }>('/v1/onboarding/step', request, requestOptions);
  }
}
